import React, { useState } from 'react';
import TermsAndConditions from './TermsAndConditions'; // Импортируем новый компонент

const RescheduleForm = ({ handleSubmit, setCurrentView }) => {
    const [termsAccepted, setTermsAccepted] = useState(false);

    return (
        <div id="rescheduleForm" className="form-container">
            <h2>Заказать перестановку</h2>
            <form onSubmit={(e) => handleSubmit(e, 'reschedule')}>
                <label htmlFor="rescheduleAmount">Сумма перестановки:</label>
                <input type="number" id="rescheduleAmount" name="amount" required />

                <label htmlFor="rescheduleCityGive">В каком городе отдаете наличку:</label>
                <input type="text" id="rescheduleCityGive" name="cityGive" required />

                <label htmlFor="rescheduleCityReceive">В каком городе желаете получить наличные:</label>
                <input type="text" id="rescheduleCityReceive" name="cityReceive" required />

                <label htmlFor="rescheduleTelegram">Телеграм для связи:</label>
                <input type="text" id="rescheduleTelegram" name="telegram" required />

                <TermsAndConditions
                    isChecked={termsAccepted}
                    onCheckboxChange={() => setTermsAccepted(!termsAccepted)}
                    onShowRules={() => setCurrentView('rules', 'reschedule')} // Передаем текущий view для возврата
                />
                <button type="submit" disabled={!termsAccepted}>Отправить заявку</button>
                <button type="button" onClick={() => { setCurrentView('mainMenu'); setTermsAccepted(false); }}>Назад в главное меню</button>
            </form>
        </div>
    );
};

export default RescheduleForm; 